import DatePickerContent from './Content';
import DatePickerRoot from './Root';
import DatePickerTrigger from './Trigger';

const DatePicker = {
  Trigger: DatePickerTrigger,
  Root: DatePickerRoot,
  Content: DatePickerContent,
};

export default DatePicker;
